import React, { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';

// Mesma motivacao do CurrencyTextField: com thousandSeparator='.' BR, o
// NumericFormat v5 precisa de valueIsNumericString=true quando o value pode
// chegar como string (Sequelize DECIMAL, etc), senao a heuristica confunde
// thousand separator com decimal.
const FloatTextField = forwardRef(
  ({ decimalScale = 2, onChange, value, ...other }, ref) => (
    <NumericFormat
      {...other}
      value={value === '' || value === null || value === undefined ? '' : String(value)}
      valueIsNumericString
      getInputRef={ref}
      onValueChange={(values) => {
        onChange(values.floatValue);
      }}
      thousandSeparator={'.'}
      decimalSeparator={','}
      decimalScale={decimalScale}
      fixedDecimalScale={true}
    />
  )
);

export default FloatTextField;
